var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStorybook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.498 30.928 5.071 1.664H4l1.07 29.264z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M7.093 30.93 5.666 1.664 23.323.405l-.29 3.877L24.72 3.01l1.406 1.272V.204L28.982 0v32zM23.9 12.41l-4.596.114c.085-2.398-.942-2.626-1.513-2.626-.543 0-1.456.17-1.456 1.456 0 1.309 1.335 2.048 2.902 2.916 2.226 1.232 4.92 2.724 4.92 6.477 0 3.597-2.798 5.253-6.366 5.253-3.683 0-6.91-1.256-6.538-6.767h4.825c-.058 2.227.428 3.027 1.655 3.027.943 0 1.37-.543 1.37-1.456 0-1.383-1.39-2.199-2.99-3.137-2.167-1.271-4.718-2.767-4.718-6.2 0-3.425 2.256-5.71 6.281-5.71s6.338 2.2 6.224 6.653",
  clipRule: "evenodd"
})));
export default SvgStorybook;